
import React from 'react';
import { BookOpen, Layout, Calendar, Smile, Users } from 'lucide-react';
import { Tab } from '../types';

interface MobileBottomNavProps {
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ activeTab, setActiveTab }) => {
  // 5 个核心功能
  const items = [
    { id: 'articles' as Tab, label: '手记', icon: <BookOpen size={20} /> },
    { id: 'space' as Tab, label: '空间', icon: <Layout size={20} /> },
    { id: 'workshops' as Tab, label: '工坊', icon: <Users size={20} /> },
    { id: 'booking' as Tab, label: '预约', icon: <Calendar size={20} /> },
    { id: 'mood' as Tab, label: '情绪', icon: <Smile size={20} /> },
  ];

  const handleNavClick = (id: Tab) => {
    setActiveTab(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[100] bg-white/98 backdrop-blur-xl border-t border-stone-200/50 pb-safe shadow-[0_-4px_12px_rgba(0,0,0,0.03)]">
      <div className="flex items-center justify-between h-14">
        {items.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className="flex-1 flex flex-col items-center justify-center h-full relative active:scale-90 transition-transform duration-200"
            >
              <div className={`transition-all duration-300 mb-0.5 ${isActive ? 'text-amber-700 scale-110' : 'text-stone-400'}`}>
                {item.icon}
              </div>
              
              <span className={`text-[9px] font-serif font-black tracking-[0.2em] transition-all duration-300 ${isActive ? 'text-amber-700' : 'text-stone-400'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
